module.exports = __webpack_public_path__ + "img/vip.5c10d273.gif";